import { CSSProperties } from 'react';
import { F0, F1, TypedValue } from '@client/new/helpers/types';
import { Col, Row } from '@design-system/components/grid/grid';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Tooltip } from '@design-system/components/tooltip/tooltip';

export const FormRowHeader = (
  p: Pick<FormRowsProps, 'styleSchema'> & { style: CSSProperties },
) => (
  <Row style={p.style}>
    {p.styleSchema.map((cell, i) => (
      <Tooltip
        title={cell.tooltip}
        key={i}
        variant="dark"
        tooltipProps={{ width: 175 }}
      >
        <Col style={{ fontWeight: 'bold' }}>{cell.title}</Col>
      </Tooltip>
    ))}
  </Row>
);

export type CellTextInput = TypedValue<
  'text-input',
  { onChange: F1<string>; value: string }
>;

export type CellNumberInput = TypedValue<
  'number-input',
  { onChange: F1<string>; min?: number; max?: number; value: number }
>;

export type CellLabel = TypedValue<'label', string>;
export type CellButton = TypedValue<
  'icon-button',
  { icon: IconProp; onClick: F0 }
>;

export type Cell = CellTextInput | CellNumberInput | CellLabel | CellButton;
export type Row = { values: Array<Cell>; id: string };

export type StyleSchema = {
  width?: string | number;
  title?: string;
  tooltip?: string;
};

export type FormRowsProps = {
  styleSchema: Array<StyleSchema>;
  values: Array<Row>;
};
